import { FINANCE_CALCULATOR, INSURANCE_CALCULATOR } from "../../../../common-deprecated/constants";
import { scrollTargetIntoView } from "../../../../common-deprecated/utils";
import { setFinanceCollapsable, setInsuranceCollapsable } from "../redux/actions/FinanceInsuranceActions";
import type { BuildAndBuyDispatchType } from "../redux/store";
import type { FinanceInsuranceCalculatorType } from "./FinanceInsuranceCalculatorLink";

export const scrollIntoViewAndOpen = (
    dispatch: BuildAndBuyDispatchType,
    target: FinanceInsuranceCalculatorType,
    active: boolean,
): void => {
    switch (target) {
        case FINANCE_CALCULATOR:
            dispatch(setFinanceCollapsable(active));
            break;
        case INSURANCE_CALCULATOR:
            dispatch(setInsuranceCollapsable(active));
            break;
    }
    scrollTargetIntoView(`${target}-injection-container`, false, true, true);
};

/**
 * Determine if button should be enabled
 * @param container Container to navigate
 * @param direction Boolean param (true is forward, false is backwards)
 */
export const isScrollToElementPossible = (container: HTMLDivElement | null, direction: boolean): boolean => {
    if (!container) return false;
    const { scrollLeft, clientWidth, scrollWidth } = container;
    if (!direction) {
        return scrollLeft > 0;
    } else {
        return scrollLeft + clientWidth < scrollWidth;
    }
};

/**
 * Navigate to the next element in the container
 * @param container Container to navigate
 * @param direction Boolean param (true is forward, false is backwards)
 * Note: This logic only works if the elements have scroll-snap-align: start
 */
export const scrollToElement = (container: HTMLDivElement, direction: boolean): void => {
    const children = Array.from(container.children);
    const containerLeftOffset = container.getBoundingClientRect().left;

    const currentElement = children.find((child) => {
        return child.getBoundingClientRect().left - containerLeftOffset === 0;
    });
    if (!currentElement) return undefined;
    const currentElementIndex = children.findIndex((child) => child === currentElement);

    const target = children.find((child, childIndex) => {
        if (direction) {
            return childIndex === currentElementIndex + 1;
        } else {
            return childIndex === currentElementIndex - 1;
        }
    }) as HTMLElement;
    if (!target) return undefined;
    container.scrollTo({ left: target.offsetLeft - containerLeftOffset, behavior: "smooth" });
};
